import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { LineMessageLogQueryKey } from '../../constants'
import LineMessageLogService from '../services'
import { components } from '@/schema'

type LineAutoMessageLogModel =
	components['schemas']['AdminLineAutoMessageLogModel']

function useQueryGetLineMessageLogById(
	logId: string,
	props?: UseBaseQueryOptions<LineAutoMessageLogModel>,
) {
	return useQuery({
		queryKey: [LineMessageLogQueryKey.GetLineMessageLogs, 'byId', logId],
		queryFn: () => LineMessageLogService.getLineMessageLogById(logId),
		enabled: !!logId,
		...props,
	})
}

export default useQueryGetLineMessageLogById
